export enum ComparisonStatus {
  Identical = 'identical',
  Different = 'different',
  EmptyInA = 'emptyInA',
  EmptyInB = 'emptyInB',
  MissingInA = 'missingInA',
  MissingInB = 'missingInB',
}
